import { render, staticRenderFns } from "./TreeNodeView.vue?vue&type=template&id=48d38ddc&lang=pug&"
import script from "./TreeNodeView.vue?vue&type=script&lang=ts&"
export * from "./TreeNodeView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports